import React, { useState, Suspense, useEffect } from "react";
import { Typography, Box, FormControl, RadioGroup } from "@mui/material/";
import { useObjectStore } from "../zustand/objects";
import DeleteIcon from "@mui/icons-material/Delete"
import Grid2 from "@mui/material/Grid2";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Modal from '@mui/material/Modal';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import Tooltip from '@mui/material/Tooltip';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import PersonPinOutlinedIcon from '@mui/icons-material/PersonPinOutlined';
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';


// MANTINE
import { Stack, Card, Button,  Switch, Text, Group, Slider, ActionIcon, Loader, Textarea, useMantineTheme } from '@mantine/core';

import shortid from "shortid";

import ModelAttributions from "../ModelAttributions.json";
import { getSinglePose, isFigmaFrameMine } from "../api.js"

import ObjectTitleName from './ObjectTitleName';
import ModelColourButton from './ModelColourButton';
import TextObjectBackgroundColourButton from './TextObjectBackgroundColourButton';
import LinksToButton from './LinksToButton';
import PosesButton from './PosesButton';
import ChangeScaleLayerListButtons from './ChangeScaleLayerListButtons';
import { ConstructionOutlined } from "@mui/icons-material";

const LayerListItem = ({
  id,
  object,
  category,
  position,
  scale,
  rotation,
  destination,
  content,
  textKind,
  colour,
  bGColour,
  pose,
  title,
  texture,
  isLocked, 
  matrix,
  figmaID,
  image,
  imageSize,
  curved,
  curveAmount,
  uploadedURL
}) => {
  const {
    artboards,
    updateIsLocked,
    removeObject,
    currentObjectArtboard,
    objectsAreLoaded,
    updateObjectSelected,
    transformModeChange,
    selectedObjectID,
    updateTextContent,
    transformMode,
    switchImageModalOpen, 
    setImagePurpose,
    setEditingID,
    updateImageTexture,
    addToGroupedObjects,
    removeFromGroupedObjects,
    groupedObjects,
    grouping,
    copyObject,
    updateFigmaURL,
    textModalOpen,
    switchTextModalOpen,
    arrangeUndoRedo,
    editingObjectTitle
  } = useObjectStore();

    const theme = useMantineTheme();
  
const borderColour = theme.colors.secondary[5]
  
  const removeObjectFunction = (val) => {
    // send current state to undoActions
    arrangeUndoRedo({
      updateType: "objectRemove", 
      artboard: val.currentObjectArtboard, 
      objectID: val.id,
      undo:false
      })
      // send update to zustand
    removeObject(val)

  }

  const [textValue, setTextValue] = useState(content)
  const [textOpen, setTextOpen] = useState(false);
  const [attrOpen, setAttrOpen] = useState(false);
  const [isMine, setIsMine] = useState(false);

  const openListItem = () => {
    updateObjectSelected(id);
  };

  const closeListItem = () => {
    updateObjectSelected('0');
  };
  

  const onEditTextClick = () => {
    setTextOpen(true)
    switchTextModalOpen(true) 
  }

  const onAttrClick = () => {
    setAttrOpen(true)
  }

  const onTextSubmit = () => {
    // send current state to undoActions
    arrangeUndoRedo({
      updateType: "objectUpdate", 
      artboard: currentObjectArtboard, 
      objectID: id,
      undo:false, 
      field: "content"
      })
      // send update to zustand
    updateTextContent({ id, currentObjectArtboard, content: textValue, undo: false })
    setTextOpen(false)
    switchTextModalOpen(false)
  }

  const onTextCancel = () => {
    setTextOpen(false)
  }

  const onAttrCancel = () => {
    setAttrOpen(false)
  }

  const handleChange = (e) => {
    setTextValue(e.target.value)
  }

  const onAddImageTextureClick = () => {
    setEditingID(id)
    switchImageModalOpen()
    setImagePurpose("texture")
}

  const onEditImageURLClick = () => {
    setEditingID(id)
    switchImageModalOpen()
    setImagePurpose("objectEdit")
} 

const onDeleteImageTextureClick = () => {
  // send current state to undoActions
  arrangeUndoRedo({
    updateType: "objectUpdate", 
    artboard: currentObjectArtboard, 
    objectID: id,
    undo:false,
    field: "imageTexture"
    })
    // send update to zustand
  updateImageTexture(id, currentObjectArtboard, null, false)
}

const onLockItemClick = () => {
  // send current state to undoActions
  arrangeUndoRedo({
    updateType: "objectUpdate", 
    artboard: currentObjectArtboard, 
    objectID: id,
    undo:false,
    field: "isLocked"
    })
    // send update to zustand
  updateIsLocked({id: id, undo: false})
  !isLocked ? updateObjectSelected('0') : 
  updateObjectSelected(id)
}
 
  const onCopyItemClick = () => {
    const newID = shortid.generate()
    // send update to zustand first (so we have state to grab for undo array)
    copyObject({ currentObjectArtboard: currentObjectArtboard, id: id, newID: newID, undo: false })
    // send current state to undoActions
    arrangeUndoRedo({
      updateType: "objectAdd",
      artboard: currentObjectArtboard,
      objectID: newID,
      undo: false
    })
  }

const checkboxClick = (e) => {
  e.currentTarget.checked ? addToGroupedObjects(id) : removeFromGroupedObjects(id) 
  console.log(groupedObjects)
}

const updateFrameURL = () => {
  updateFigmaURL({id: id, currentObjectArtboard: currentObjectArtboard, figmaID: figmaID, undo: false})
}

useEffect(() => {
  category === "figma" && isFigmaFrameMine(figmaID).then(res => setIsMine(res))
  function handleKeyDown(event) {
    if (event.repeat) { return }  
    if (event.key === 'd' && (event.ctrlKey || event.metaKey))  {    
      event.preventDefault();
      onCopyItemClick()
    }
  }
  document.addEventListener("keydown", handleKeyDown)

  return () => document.removeEventListener("keydown", handleKeyDown)
}, [])

  if (!objectsAreLoaded) {
    return <div><Loader color="black" />Loading...</div>;
  } else {
    return (
      <Suspense fallback={null}> 
      <>

        {/* CC ATTRIBUTION Modal */}
        {id !== "camera" && category !== "aiModel" && category !== "shape" && category !== "text" && category !== "image" && category !== "UI" && category !== "figma" && category !== "uploaded" && category !== "apple" && category !== "microsoft" && category!== "floatgridsUi"  && category!== "floatgridsLayout" &&  <AttributionModal attrOpen={attrOpen} onAttrCancel={onAttrCancel} id={id} category={category} object={object} pose={pose} ModelAttributions={ModelAttributions} />}
        {/* TEXT MODAL */}
        <Modal
          open={textOpen}
          onClose={onTextCancel}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
         <Card style={{borderRadius:32, width: 500, padding:0,
        height: 180,  top: '50%', overflow:'hidden',
        left: '50%',position: 'absolute',transform: 'translate(-50%, -50%)'}}>
          <Grid2 container style={{padding:20}}>
          <Grid2 item xs={12}>
            <Text size="xl" fw={700}>
              Edit text
            </Text>
            </Grid2>
            <Grid2 item xs={12}>
            <Textarea
              value={textValue}
              onChange={handleChange}
            />
            </Grid2>
            <Grid2 item xs={12}>
            <Group>
            <Button style={{
             paddingTop: 1, paddingBottom: 1, marginTop: 15, inline: true, fontSize: 12, backgroundColor: 'black', borderRadius: 32
          }} onClick={() => onTextCancel()}>Cancel</Button>
            <Button style={{
             paddingTop: 1, paddingBottom: 1, marginTop: 15, inline: true, fontSize: 12, backgroundColor: 'black', borderRadius: 32
          }} onClick={() => onTextSubmit()}>Submit</Button>
            </Group>
            </Grid2>
            </Grid2>
          </Card>
        </Modal>

         {/* OLD CODE FOR THIS IS IN NOTES (OR GITHUB) */}
          <Stack w={'100%'} gap={7}>
            {isLocked ?
              <Button style={{
                paddingTop: 1, paddingBottom: 1, marginTop: 5, inline: true, fontSize: 12, backgroundColor: 'black', borderRadius: 32
              }} onClick={() => onLockItemClick()} leftSection={<LockIcon fontSize="24" />}>Unlock</Button> :
              <Grid2 container spacing={2} style={{
                cursor: "pointer"
              }}></Grid2>}

              {/******************************************
                    Edit text and update size buttons 
              ******************************************/}
            <Group justify="space-between" w={'100%'}>
              {category === "text" ? (<Tooltip title="Edit text">
                <ActionIcon onClick={() => !isLocked && onEditTextClick()} size={'md'} variant="outline" aria-label="Settings" color={borderColour}>
                  <EditNoteOutlinedIcon style={{ width: '70%', height: '70%' }} stroke={1.5} />
                </ActionIcon></Tooltip>) :
                <ObjectTitleName open={true} id={id} title={title} borderColour={borderColour} />}
              <ChangeScaleLayerListButtons matrix={matrix} id={id} currentObjectArtboard={currentObjectArtboard} borderColour={borderColour} />
            </Group>

            {/******************************************
                    Pose, Colour, Background colour and 'Links to' selects
              ******************************************/}
              <Stack gap={1}>
            <PosesButton pose={pose} id={id} object={object} />
            {category !== "ai" && id !== "camera" && id !== "image" && category !== "figma" && category !== "apple" && category !== "microsoft" && category !== "floatgridsUi" && category !== "floatgridsLayout" && category !== "uploaded" && (
              <ModelColourButton colour={colour} id={id} />
            )}
              {category === "text" && <TextObjectBackgroundColourButton bGColour={bGColour} id={id} />}
              <LinksToButton id={id} destination={destination} />
              </Stack>


            {/******************************************
                    Curve Toggle, Set shape texture, Edit image
              ******************************************/}
            <Stack gap={1}>
              {
                (
                  (category === "image") ||
                  (category === "figma") ||
                  (category === "apple") ||
                  (category === "background") ||
                  (category === "microsoft") ||
                  (category === "floatgridsUi") ||
                  (category === "floatgridsLayout")
                ) && (
                  <CurveToggle curved={curved} curveAmount={curveAmount} id={id} />
                )
              }
            {category === "shape" && (
                <Group wrap="nowrap" gap={0}>
                  <Button onClick={() => onAddImageTextureClick()}
                    style={{
                      height: 28, width: texture ? 80 : 100, inline: true, marginTop: 15, fontSize: 12, backgroundColor: 'black',
                      borderTopLeftRadius: 32, borderBottomLeftRadius: 32, borderTopRightRadius: texture ? 0 : 32, borderBottomRightRadius: texture ? 0 : 32
                    }}>
                    Texture</Button>
                  {texture && (<ActionIcon
                    onClick={() => onDeleteImageTextureClick()}
                    variant="filled"
                    color='black'
                    size={'xs'}
                    style={{ marginLeft: 2, height: 28, inline: true, marginTop: 15, fontSize: 12, borderTopLeftRadius: 0, borderBottomLeftRadius: 0, borderTopRightRadius: 32, borderBottomRightRadius: 32 }}
                  >
                    <DeleteIcon style={{ width: 15 }} size={'xs'} />
                </ActionIcon>)}
              </Group>)}

            {(category === "image") && (
                <Button onClick={() => onEditImageURLClick()}
                  style={{
                    height: 28, paddingTop: 1, paddingBottom: 1, inline: true, marginTop: 15, fontSize: 12, backgroundColor: 'black',
                    borderRadius: 32
                  }}>
                    Edit image</Button>
            )}</Stack>

            {/******************************************
                    Refresh Figma, View creator, Copy, Lock, Delete
              ******************************************/}
            <Group justify="space-between" w={'100%'}>
              <Group gap={5}>
                {category === "figma" && isMine && <Tooltip title="Refresh frame">
                  <ActionIcon onClick={() => !isLocked && updateFrameURL()} size={'md'} variant="outline" aria-label="Settings" color={borderColour}>
                    <RefreshOutlinedIcon style={{ width: '70%', height: '70%' }} stroke={1.5} />
                  </ActionIcon></Tooltip>}

                {category !== "ai" && category !== "shape" && category !== "text" && category !== "image" && category !== "figma" && category !== "apple" && category !== "microsoft" && category !== "UI" && category !== "floatgridsUi" && category !== "floatgridsLayout" && category !== "uploaded" &&
                  <Tooltip title="View creator">
                    <ActionIcon onClick={() => onAttrClick()} size={'md'} variant="outline" aria-label="Settings" color={borderColour}>
                      <PersonPinOutlinedIcon style={{ width: '70%', height: '70%' }} stroke={1.5} />
                    </ActionIcon></Tooltip>}
              </Group>
              <Group gap={5}>
                {category !== "figma" && <Tooltip title="Copy object">
                  <ActionIcon onClick={() => onCopyItemClick()} size={'md'} variant="outline" aria-label="Settings" color={borderColour}>
                    <ContentCopyIcon style={{ width: '70%', height: '70%' }} stroke={1.5} /></ActionIcon>
                </Tooltip>}

                <Tooltip title="Lock controls">
                  <ActionIcon onClick={() => onLockItemClick()} size={'md'} variant="outline" aria-label="Settings" color={borderColour}>
                    <LockOpenIcon style={{ width: '70%', height: '70%' }} stroke={1.5} /></ActionIcon>
                </Tooltip>

                <Tooltip title="Delete object">
                  <ActionIcon onClick={() => removeObjectFunction({ currentObjectArtboard: currentObjectArtboard, id: id, undo: false, content: content, textKind: textKind, object: object, category: category, position: position, scale: scale, rotation: rotation, matrix: matrix, colour: colour, image: image, imageSize: imageSize, imageTexture: texture, curved: curved, curveAmount: curveAmount, pose: pose, uploadedURL: uploadedURL })} size={'md'} variant="subtle" aria-label="Settings" color={borderColour}>
                    <DeleteIcon stroke={1.5} /></ActionIcon>
                </Tooltip>
              </Group>
            </Group>
          </Stack>
          
          
      </> 
      </Suspense>
    );
  }
};

export default LayerListItem;


const CurveToggle = ({curved, id, curveAmount}) => {

  const {updateCurved, updateCurveAmount, arrangeUndoRedo, currentObjectArtboard} = useObjectStore()
 
  const handleChange = () => {
    // send current state to undoActions
    arrangeUndoRedo({
      updateType: "objectUpdate", 
      artboard: currentObjectArtboard, 
      objectID: id,
      undo:false,
      field: "curved"
      })
      // send update to zustand
    updateCurved({id:id, undo: false})
  }
  const handleChangeCurveAmount = (e) => {
    // send current state to undoActions
    arrangeUndoRedo({
      updateType: "objectUpdate", 
      artboard: currentObjectArtboard, 
      objectID: id,
      undo:false,
      field: "curveAmount"
      })
      // send update to zustand
    updateCurveAmount({id:id, val:e, undo: false})
  }



  return (
    <div style={{width:"100%", paddingTop:8, paddingBottom:8}}>
    <Switch
      color="black"
      fw={500} size={'xs'}
      label="Curve"
      onChange={() => handleChange()} type="checkbox" name="curve" checked={curved}
    />
    {curved && <Slider
        color="black"
        defaultValue={curveAmount}
        onChange={(e) => handleChangeCurveAmount(e)}
        step={1}
        marks={[{ value: 0 },{ value: 3 },{ value: 6 },{ value: 9},{ value: 12 }]}
        min={1}
        max={12}
      />}
      </div>


  )
}


const AttributionModal = ({attrOpen, onAttrCancel, id, category, object, pose, ModelAttributions}) => {
  
const [attributionInfo, setAttributionInfo] = useState(null)

  useEffect(() => {
    attrOpen && getSinglePose(pose.name).then(e => setAttributionInfo(e.attribution))
  },[attrOpen])

  return (
    <Modal
      open={attrOpen}
      onClose={onAttrCancel}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Card style={{
        width: 400, borderRadius: 32, padding: 0, top: '50%', overflow: 'hidden',
        left: '50%', position: 'absolute', transform: 'translate(-50%, -50%)'
      }}>
        <div style={{ width: '100%', height: "100%", padding: 20, paddingTop: 10, margin: 0, backgroundImage: 'url("/image/background-grid.png")' }}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Model Attribution
          </Typography>
          {attributionInfo ?
            <Suspense key={id} fallback={null}>
              <Typography>
                {attributionInfo}
              </Typography>
            </Suspense> :
            <Loader color="black" />}

          <Button style={{
            paddingTop: 1, paddingBottom: 1, marginTop: 15, inline: true, fontSize: 12, backgroundColor: 'black', borderRadius: 32
          }} onClick={() => onAttrCancel()}>Close</Button>
        </div>
      </Card>
    </Modal>
  )
}